export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isTop: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时，粉丝集体脱粉',
    excerpt: '据知情人爆料，某当红顶流男星近日被拍到深夜与一名神秘女子一同进入某五星级酒店，两人在酒店内停留长达8小时后才分别离开。该消息一出，粉丝圈瞬间炸锅，大批粉丝表示无法接受。',
    content: `<p>近日，一则关于某顶流男星的爆料在网络上迅速发酵。据多位目击者称，该男星于上周五深夜11点左右，驾驶私人座驾抵达北京某五星级酒店地下停车场。</p>
<p>目击者描述，当时男星戴着口罩和帽子，刻意压低帽檐，试图掩饰身份。但熟悉他的粉丝一眼就能认出其身形和走路姿态。随后，一名身着黑色连衣裙的神秘女子从酒店大堂走出，两人简短交流后一同进入了电梯。</p>
<p>据酒店内部人员透露，两人在酒店行政套房内停留了约8个小时，直到次日清晨7点左右才分别离开。男星先行离开，女子则在一小时后才从酒店正门走出，乘坐一辆网约车离开。</p>
<p>消息传开后，该男星的粉丝后援会瞬间炸开了锅。有粉丝表示"完全无法接受"，也有理性粉丝呼吁"等官方回应"。截至目前，该男星及其工作室均未对此事做出任何回应。</p>
<p>值得一提的是，该男星此前一直以"单身人设"示人，多次在公开场合表示自己专注事业、无心恋爱。此次事件曝光后，其"单身人设"遭到严重质疑。</p>
<p>业内人士分析，如果此事属实，该男星的商业价值将受到较大影响。据悉，其目前手握多个一线品牌代言，品牌方已开始密切关注事态发展。</p>`,
    category: 'mingxing',
    categoryName: '明星黑料',
    author: '黑料小编',
    publishDate: '2026-08-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20silhouette%20of%20a%20male%20celebrity%20walking%20into%20a%20luxury%20hotel%20at%20night%2C%20dark%20atmospheric%20lighting%2C%20paparazzi%20style%20photography%2C%20dramatic%20shadows%2C%20urban%20night%20scene%2C%20cinematic%20noir%20aesthetic&width=800&height=500&seq=article-1-hero&orientation=landscape',
    tags: ['顶流男星', '密会', '酒店', '单身人设', '粉丝脱粉'],
    views: 128500,
    isHot: true,
    isTop: true,
  },
  {
    id: 'article-2',
    title: '千万粉丝网红直播翻车，假货风波持续发酵，品牌方宣布解约',
    excerpt: '拥有两千万粉丝的知名带货网红近日在直播中被网友实锤售卖假冒化妆品，涉事品牌方火速宣布终止合作。该网红直播间已暂停直播，疑似面临巨额赔偿。',
    content: `<p>一场直播翻车事件正在持续发酵。拥有超过两千万粉丝的头部带货网红"XX美妆达人"在上周六的直播中，被眼尖的网友发现其售卖的某国际大牌化妆品存在明显瑕疵。</p>
<p>网友对比发现，该网红直播间售卖的粉底液外包装与正品存在多处差异，包括字体印刷粗糙、瓶身logo位置偏移、防伪码无法验证等问题。随后，多位购买者在社交平台晒出实物对比图，证实所购产品确为假货。</p>
<p>事件曝光后，涉事品牌方迅速发布声明，宣布与该网红终止所有合作关系，并表示将保留追究法律责任的权利。声明中强调："品牌始终坚持正品保障，对于任何损害品牌声誉和消费者权益的行为零容忍。"</p>
<p>该网红起初在社交平台发文否认，声称"被同行恶意竞争陷害"，但在越来越多的实锤证据面前，最终发布了一段道歉视频，泪洒镜头前向粉丝和消费者致歉。</p>
<p>然而，道歉并未平息消费者的怒火。据悉，已有超过5000名消费者联合发起维权，要求"退一赔三"。按照相关法律法规，该网红可能面临高达数千万元的赔偿。</p>
<p>这已不是该网红第一次陷入争议。去年其就曾因虚假宣传被市场监管部门约谈，此次假货事件无疑是雪上加霜。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    author: '黑料小编',
    publishDate: '2026-08-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20livestreaming%20setup%20with%20beauty%20products%20scattered%20on%20a%20desk%2C%20dark%20atmosphere%2C%20one%20spotlight%20on%20a%20fake%20cosmetic%20product%2C%20dramatic%20lighting%2C%20investigative%20journalism%20style%2C%20tense%20mood&width=800&height=500&seq=article-2-hero&orientation=landscape',
    tags: ['网红翻车', '假货', '直播带货', '品牌解约', '消费者维权'],
    views: 96300,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-3',
    title: '娱乐圈大佬被曝性骚扰多名女艺人，行业潜规则再引热议',
    excerpt: '多位女艺人联合实名举报某娱乐圈资深大佬长期利用职务之便对旗下女艺人进行性骚扰。事件引发行业震动，多家影视公司紧急发布声明与涉事人员划清界限。',
    content: `<p>一场由多位女艺人发起的联合实名举报，正在娱乐圈掀起惊涛骇浪。被举报的是一位在娱乐圈深耕二十余年的资深大佬，其旗下公司曾制作过多部知名影视作品。</p>
<p>据举报者之一的演员A女士透露，该大佬在2019年至2025年期间，多次以"谈工作"为由将其约至私人会所，期间进行言语挑逗和肢体接触。A女士表示："我当时刚入行，不敢得罪他，只能默默忍受。"</p>
<p>另一位举报者B女士的说法更加令人震惊。她声称在一次剧组杀青宴后，该大佬以"送她回家"为由，在车内对她进行了猥亵行为。B女士说："这么多年我一直活在阴影中，现在终于有勇气站出来了。"</p>
<p>截至目前，已有7位女艺人公开发声，指控内容惊人地相似。她们均表示，该大佬利用其在行业内的权势地位，对年轻女艺人进行长期的精神控制和性骚扰。</p>
<p>事件曝光后，多家与该大佬有合作关系的影视公司紧急发布声明，宣布终止一切合作。中国电视剧制作产业协会也表示将对此事展开调查。</p>
<p>法律界人士指出，如果举报内容属实，该大佬的行为已涉嫌违法犯罪，可能面临刑事追诉。同时，这起事件也再次引发了公众对娱乐圈"潜规则"问题的广泛讨论。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    author: '黑料小编',
    publishDate: '2026-08-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20silhouette%20of%20a%20powerful%20man%20in%20a%20suit%20behind%20a%20large%20desk%2C%20dramatic%20shadows%2C%20film%20noir%20style%2C%20tense%20atmosphere%2C%20corporate%20power%20abuse%20theme%2C%20cinematic%20lighting&width=800&height=500&seq=article-3-hero&orientation=landscape',
    tags: ['娱乐圈', '性骚扰', '潜规则', '联合举报', '行业震动'],
    views: 156200,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-4',
    title: '某知名女星被爆隐婚生子，孩子已上小学，老公身份成谜',
    excerpt: '有媒体拍到某知名女星频繁接送一名小学生上下学，经多方核实，该儿童疑为其亲生儿子。女星此前从未公开过婚姻状况，隐婚生子一事引发热议。',
    content: `<p>娱乐圈再爆猛料！某知名女星被媒体拍到连续多日接送一名约7-8岁的小学生上下学，两人互动亲密，疑似母子关系。</p>
<p>据跟拍记者描述，该女星每日清晨7点准时驾车送孩子到某国际学校门口，下午3点半又准时出现在校门口接孩子放学。接送过程中，女星与孩子的互动十分自然亲密，孩子多次称呼其为"妈妈"。</p>
<p>更令人惊讶的是，通过多方核实，该儿童出生证明上的母亲姓名与该女星的真实姓名完全一致。这意味着，该女星至少已经隐婚7年以上。</p>
<p>该女星出道十余年来，从未公开过任何恋情，更未提及婚姻状况。她曾在多次采访中表示自己"享受单身生活"，"工作太忙没时间恋爱"。如今隐婚生子的消息曝光，她精心维护多年的"单身独立女性"形象瞬间崩塌。</p>
<p>关于孩子父亲的身份，目前仍是谜团。有知情人士透露，孩子父亲可能是某低调富豪，长期在国外生活。也有说法称是圈内某位已婚男星，但该说法尚无实质性证据。</p>
<p>截至目前，该女星的工作室仅回应"艺人私事不便回应"，未正面确认或否认此事。但大量网友认为，不否认基本等于默认。</p>`,
    category: 'mingxing',
    categoryName: '明星黑料',
    author: '黑料小编',
    publishDate: '2026-08-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20female%20celebrity%20wearing%20sunglasses%20and%20a%20hat%20picking%20up%20a%20child%20from%20school%20gate%2C%20paparazzi%20style%20candid%20photography%2C%20afternoon%20sunlight%2C%20suburban%20school%20setting%2C%20secretive%20mood&width=800&height=500&seq=article-4-hero&orientation=landscape',
    tags: ['隐婚生子', '女星', '人设崩塌', '私生活'],
    views: 112800,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-5',
    title: '巴厘岛偶遇知名情侣疑似分手，女方独自现身神情落寞',
    excerpt: '网友在巴厘岛偶遇此前公开恋情的某知名情侣，女方独自一人在海边散步，神情落寞。而男方则在同一天被拍到现在北京与友人聚会，两人疑似已经分手。',
    content: `<p>曾被粉丝称为"神仙眷侣"的某知名情侣，近日传出分手消息。有网友在巴厘岛度假时偶遇女方独自一人在海边散步，神情十分落寞。</p>
<p>该网友描述，当时是傍晚时分，沙滩上游客稀少。女方穿着一条白色长裙，赤脚走在沙滩上，时不时停下来望着远方发呆。网友表示："她看起来心情很不好，眼睛好像哭过一样，有点红肿。"</p>
<p>值得注意的是，就在同一天，男方被拍到在北京某高档餐厅与一群友人聚餐，席间谈笑风生，完全看不出有任何异常。</p>
<p>这对情侣于2024年公开恋情后，一直以甜蜜恩爱的形象示人，频繁在社交平台上互动秀恩爱。但细心的粉丝发现，两人已经有两个月没有在公开场合同框，社交平台上的互动也彻底停止。</p>
<p>更有粉丝扒出，女方近日删除了社交平台上多条与男方有关的动态，而男方的关注列表中也已经找不到女方的账号。这些迹象都指向两人关系已经出现严重问题。</p>
<p>两人的经纪公司目前均未对此事做出回应。但根据娱乐圈的惯例，如果双方保持沉默超过一周，基本可以确认分手消息属实。</p>`,
    category: 'bagua',
    categoryName: '八卦爆料',
    author: '黑料小编',
    publishDate: '2026-08-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20lonely%20woman%20in%20a%20white%20dress%20walking%20alone%20on%20a%20beach%20at%20sunset%2C%20melancholic%20atmosphere%2C%20soft%20golden%20light%2C%20Bali%20beach%20scene%2C%20emotional%20solitude%2C%20cinematographic%20composition&width=800&height=500&seq=article-5-hero&orientation=landscape',
    tags: ['情侣分手', '巴厘岛', '感情危机', '娱乐圈恋情'],
    views: 87500,
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-6',
    title: '某综艺节目黑幕曝光，冠军内定、投票造假，节目组紧急回应',
    excerpt: '一位自称是某热门综艺节目前工作人员的人士在网上爆料，揭露节目存在严重的冠军内定和投票造假问题。该爆料内容详实，附有多张内部聊天记录截图，引发舆论哗然。',
    content: `<p>一档收视率极高的综艺节目近日陷入黑幕风波。一位自称是该节目前工作人员的人士在社交媒体上发布长文，详细揭露了节目存在的各种造假行为。</p>
<p>该前工作人员爆料称，节目的冠军人选早在录制前三个月就已内定，所有的比赛环节和淘汰机制都是围绕内定冠军设计的。爆料人还附上了多张节目组内部微信群聊截图，截图中可以清晰看到节目导演与内定选手经纪人的对话。</p>
<p>更令人震惊的是，所谓的"观众投票"也完全是造假。爆料人称，节目组后台有一个专门的"数据操控团队"，负责实时调整投票数据显示，确保内定选手始终处于领先位置。</p>
<p>此外，该爆料还揭露了节目组如何通过恶意剪辑来操控选手形象。对于内定冠军，剪辑师会挑选最好的镜头和最感人的故事线；而对于被设定为"反派"的选手，则会刻意剪辑出负面形象。</p>
<p>面对铺天盖地的质疑，节目组发布了一份简短的官方声明，称"网络传言不实，节目始终坚持公平公正的原则"，并表示将对造谣者追究法律责任。</p>
<p>然而，这份声明并未平息舆论。大量网友表示，节目组的回应过于敷衍，要求公布原始投票数据以证清白。</p>`,
    category: 'neimu',
    categoryName: '内幕揭秘',
    author: '黑料小编',
    publishDate: '2026-08-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20view%20of%20a%20TV%20studio%20with%20stage%20lights%20and%20cameras%2C%20dark%20shadows%20in%20the%20background%2C%20dramatic%20contrast%2C%20expose%20theme%2C%20investigative%20style%2C%20mysterious%20atmosphere&width=800&height=500&seq=article-6-hero&orientation=landscape',
    tags: ['综艺节目', '投票造假', '冠军内定', '恶意剪辑', '黑幕'],
    views: 104300,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-7',
    title: '人气男团成员被曝恋爱中，与素人女友约会照流出，公司紧急公关',
    excerpt: '某当红男团成员近日被拍到与一名圈外女子亲密约会。照片中两人手牵手逛街、共进晚餐，关系十分亲密。粉丝反应两极分化，经纪公司正在紧急商讨公关策略。',
    content: `<p>当红男团成员恋爱的消息再次成为粉丝圈的焦点话题。近日，有网友在社交媒体上发布了多张某人气男团成员与一名女子约会的照片。</p>
<p>照片拍摄于上周日下午，地点是首尔江南区某高档商场。照片中可以看到，该男团成员与一名长发女子手牵手逛街，两人举止亲密，完全不避讳周围人的目光。随后，两人进入了一家日料餐厅共进晚餐。</p>
<p>据拍摄者描述，两人在餐厅内互动十分甜蜜，男方多次为女方夹菜，期间还用手轻轻抚摸女方的头发。整个约会持续了约4个小时。</p>
<p>该男团成员出道5年来，一直保持着超高的商业价值和个人形象。其经纪公司曾在多个场合强调"成员目前均以事业为重"，此次照片的曝光无疑给公司带来了巨大的公关压力。</p>
<p>粉丝对此事的反应呈现两极分化。一部分"女友粉"表示无法接受，纷纷在社交平台上表达了失望和愤怒；而另一部分理性粉丝则送上了祝福，认为偶像也有追求个人幸福的权利。</p>
<p>据悉，该男团的经纪公司已紧急召开会议商讨应对策略，预计将在近日发布官方声明。</p>`,
    category: 'mingxing',
    categoryName: '明星黑料',
    author: '黑料小编',
    publishDate: '2026-08-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20young%20kpop%20style%20male%20idol%20holding%20hands%20with%20a%20woman%20in%20a%20shopping%20mall%2C%20candid%20paparazzi%20style%2C%20bright%20mall%20lighting%2C%20secretive%20dating%20vibe%2C%20urban%20lifestyle%20photography&width=800&height=500&seq=article-7-hero&orientation=landscape',
    tags: ['男团', '恋爱曝光', '约会', '粉丝反应', '公关危机'],
    views: 135600,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-8',
    title: '网红圈爆出惊天大瓜，多位头部主播涉嫌税务问题，金额惊人',
    excerpt: '据权威消息源透露，税务部门正在对多位头部网红主播展开税务稽查，涉及金额可能高达数亿元。其中包括多位粉丝量超过千万的超级头部主播。',
    content: `<p>网红圈的税务风暴正在来袭。据多位权威消息人士透露，税务部门近期对直播带货行业展开了一次大规模的税务稽查行动。</p>
<p>据悉，此次稽查行动主要针对2023年至2025年期间的税务申报情况。初步调查发现，多位头部网红主播存在严重的偷税漏税问题，主要手段包括通过多个壳公司分散收入、虚报成本支出、利用税收洼地转移利润等。</p>
<p>涉事主播名单虽然尚未正式公布，但业内人士透露，其中包括至少3位粉丝量超过千万的超级头部主播，以及十多位粉丝量在百万级别的大主播。涉及金额初步估计在3亿至5亿元之间。</p>
<p>这并非网红行业第一次面临税务稽查。2021年，某头部带货主播就因为偷逃税款被追缴并处罚款共计13.41亿元，该事件曾引发整个行业的震动。</p>
<p>法律专家表示，根据现行税法规定，偷税漏税情节严重的，除了需要补缴税款和滞纳金外，还可能面临刑事处罚。此次被查的主播中，如果涉及金额特别巨大，不排除有人面临牢狱之灾的可能。</p>
<p>目前，多个MCN机构已经紧急要求旗下主播自查税务问题，整个行业弥漫着紧张的气氛。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    author: '黑料小编',
    publishDate: '2026-08-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20tax%20documents%20and%20calculators%20on%20a%20dark%20desk%2C%20dramatic%20lighting%2C%20financial%20investigation%20theme%2C%20serious%20mood%2C%20business%20documents%20with%20red%20stamps%2C%20dark%20atmosphere&width=800&height=500&seq=article-8-hero&orientation=landscape',
    tags: ['网红', '税务稽查', '偷税漏税', '补税', '行业震动'],
    views: 189200,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-9',
    title: '某国际电影节被曝评选不公，评审团内部矛盾激化，多位评委退出',
    excerpt: '刚刚落幕的某国际电影节陷入评选公正性争议。有评委匿名向媒体爆料，称最终获奖名单并非评审团独立评选的结果，而是受到了赞助商和主办方的强力干预。',
    content: `<p>一场关于电影艺术评价标准的争论正在某国际电影节的余波中激烈展开。多位参与评审的评委向媒体透露，本届电影节的最终获奖结果存在严重的公正性问题。</p>
<p>一位不愿透露姓名的评委在接受采访时表示："评审团的多轮投票结果和最终公布的获奖名单有显著出入。有几个奖项的结果完全违背了评审团的集体意愿。"该评委还透露，在评审过程中，主办方多次以"商业考量"和"国际合作需要"为由，暗示评审团应该考虑某些特定影片。</p>
<p>据悉，在最终的评审会议上，由于对获奖名单存在严重分歧，评审团内部爆发了激烈的争论。有3位国际评委当场表示无法接受这样的评选结果，随后宣布退出评审团以示抗议。</p>
<p>更令人震惊的是，有消息称某主要赞助商在颁奖礼前曾私下接触评审团部分成员，要求确保其投资的影片获得至少两个重要奖项。这一举动严重违反了电影节的评审独立原则。</p>
<p>截至目前，电影节官方尚未对此事做出详细回应，仅发布了一份简短声明称"评选过程严格遵循电影节章程"。但这份声明未能平息争议，反而引发了更多质疑。</p>`,
    category: 'neimu',
    categoryName: '内幕揭秘',
    author: '黑料小编',
    publishDate: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20festival%20venue%20with%20red%20carpet%20and%20empty%20seats%2C%20dramatic%20lighting%2C%20controversy%20theme%2C%20golden%20statue%20in%20shadow%2C%20tense%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-9-hero&orientation=landscape',
    tags: ['电影节', '评选不公', '商业干预', '评委退出', '公正性'],
    views: 67800,
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-10',
    title: '知名导演被前妻爆料家暴史，多段录音曝光，内容触目惊心',
    excerpt: '某知名导演的前妻近日在社交媒体上公开了多段录音，指控该导演在婚姻期间多次实施家庭暴力。录音中清晰可闻争吵声、摔东西声以及女性的哭喊求救声。',
    content: `<p>一段持续十余分钟的录音，撕开了一位知名导演精心维护的公众形象。近日，该导演的前妻在社交媒体上发布长文和多段录音，详细揭露了婚姻期间遭受的家庭暴力。</p>
<p>在其中一段录音中，可以清晰听到该导演的咆哮声、物品被摔碎的声音，以及前妻的哭喊和求救声。录音中，该导演使用大量侮辱性语言，并威胁前妻"敢说出去就让你在圈子里混不下去"。</p>
<p>前妻在长文中写道，婚后不久她就发现丈夫有严重的暴力倾向。"起初只是言语暴力，后来发展到摔东西、推搡，最后变成了拳打脚踢。"她表示自己曾多次试图离开，但每次都因为对方的威胁和道歉而心软。</p>
<p>该导演在业内以"性格温和"、"儒雅绅士"著称，曾多次在公开场合表达对女性的尊重。此次录音曝光后，其形象遭受了毁灭性的打击。</p>
<p>多家与该导演有合作关系的影视公司已紧急暂停了相关项目。其正在执导的一部投资过亿的电影也面临换导演的危机。</p>
<p>截至目前，该导演尚未对此事做出回应。但前妻表示，她已经向法院提起了诉讼，将通过法律途径维护自己的权益。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    author: '黑料小编',
    publishDate: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20broken%20picture%20frame%20on%20the%20floor%20of%20a%20dark%20room%2C%20shattered%20glass%2C%20dramatic%20shadows%2C%20domestic%20violence%20theme%2C%20dark%20atmosphere%2C%20emotional%20distress%2C%20serious%20tone&width=800&height=500&seq=article-10-hero&orientation=landscape',
    tags: ['导演', '家暴', '录音曝光', '前妻', '形象崩塌'],
    views: 143100,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-11',
    title: '某女团成员被爆霸凌队友，内部不和已久，公司试图掩盖',
    excerpt: '一位自称是某女团前工作人员的人士爆料，该团内部存在严重的霸凌现象。某位人气较高的成员长期对队友进行言语攻击和排挤，导致团队气氛极度压抑。',
    content: `<p>光鲜亮丽的舞台背后，竟然隐藏着令人窒息的霸凌文化。近日，一位自称曾在某知名女团担任助理的人士向媒体揭露了该团内部长期存在的霸凌问题。</p>
<p>据该前工作人员描述，团内一位人气最高的成员（以下简称A）长期对另外两位人气较低的成员进行各种形式的霸凌。具体行为包括：在排练时公开嘲讽队友的舞蹈能力、在休息室故意不与队友同坐、在社交媒体上发布暗示排挤队友的内容等。</p>
<p>"有一次，A当着所有工作人员的面，对一个队友说'你跳得太差了，拖累整个团的舞台效果，不如早点退团'。那个队友当场就哭了，但没人敢说什么，因为A是公司力捧的。"该工作人员回忆道。</p>
<p>更令人心寒的是，经纪公司对此心知肚明，但考虑到A是团队的核心人气成员，选择了睁一只眼闭一只眼，甚至帮助掩盖事实。公司曾要求所有工作人员签署保密协议，严禁对外透露团内矛盾。</p>
<p>消息传出后，大量粉丝表示震惊和愤怒。有不少粉丝扒出了此前各种疑似"不和"的蛛丝马迹，证实了爆料的可信度。</p>
<p>目前，该女团所属公司发布声明称"网传不实"，但未提供任何实质性证据。这种模棱两可的回应反而让更多人相信爆料属实。</p>`,
    category: 'mingxing',
    categoryName: '明星黑料',
    author: '黑料小编',
    publishDate: '2026-08-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20girl%20group%20standing%20apart%20from%20each%20other%20backstage%2C%20cold%20atmosphere%2C%20one%20member%20isolated%2C%20dramatic%20lighting%2C%20tension%20between%20people%2C%20dark%20moody%20photography&width=800&height=500&seq=article-11-hero&orientation=landscape',
    tags: ['女团', '霸凌', '队友不和', '公司掩盖', '偶像'],
    views: 92100,
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-12',
    title: '某选秀节目导师收受选手贿赂被曝光，选秀黑幕触目惊心',
    excerpt: '某选秀节目的导师被曝收受多名选手的贿赂，以"指导费"、"培训费"等名义向选手索取高额费用，承诺给予晋级和镜头保障。事件曝光后引发全行业反思。',
    content: `<p>选秀节目的背后究竟有多黑？近日，一位参加过某知名选秀节目的选手站出来揭露了节目背后令人震惊的金钱交易。</p>
<p>该选手透露，在参加节目之前，一位节目导师通过中间人向其暗示，只要支付30万元的"特别指导费"，就可以保证其在节目中走到前十名，并且获得更多的正面镜头。</p>
<p>"中间人跟我说得很直白，说这是'行业惯例'，几乎所有走到最后的选手都交了这个钱。"该选手表示，由于当时无法凑齐这笔费用，她在第二轮就被淘汰了，而一些明显实力不如她的选手却轻松晋级。</p>
<p>更令人震惊的是，这并非个别现象。据多位知情人士透露，该节目的多名导师都参与了类似的"收费保晋级"操作，收费标准从20万到50万不等，取决于选手的目标名次。</p>
<p>此外，选票造假也是公开的秘密。一位前节目组工作人员证实，节目组后台有一个庞大的数据造假系统，观众的投票数据在进入系统后会被自动"清洗"和"调整"，确保交了钱的选手获得足够的票数。</p>
<p>此事曝光后，该选秀节目的冠名赞助商已宣布暂停合作，广电部门也表示将对此事展开调查。这起事件或将推动整个选秀行业的大整顿。</p>`,
    category: 'neimu',
    categoryName: '内幕揭秘',
    author: '黑料小编',
    publishDate: '2026-08-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20spotlight%20and%20money%20falling%20in%20the%20shadows%2C%20corruption%20theme%2C%20dark%20atmosphere%2C%20dramatic%20contrast%2C%20show%20business%20scandal%2C%20mysterious%20vibe&width=800&height=500&seq=article-12-hero&orientation=landscape',
    tags: ['选秀节目', '贿赂', '导师', '造假', '黑幕'],
    views: 78100,
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-13',
    title: '知名歌手被爆抄袭国外小众音乐人，多首热门歌曲高度雷同',
    excerpt: '有音乐博主做了详细对比分析，指出某知名歌手近三年来的多首热门单曲与国外小众音乐人的作品存在高度相似。网友纷纷表示"这不是借鉴，这是照搬"。',
    content: `<p>"借鉴"还是"抄袭"？这个老生常谈的话题再次因为一位知名歌手而成为热点。近日，一位专业音乐博主发布了一段长达20分钟的对比视频，将某歌手的多首热门单曲与国外小众音乐人的作品进行了逐段对比。</p>
<p>对比结果显示，该歌手至少有5首歌曲在旋律、和声进行以及编曲结构上与国外音乐人的作品高度雷同。其中相似度最高的一首，副歌部分的旋律几乎是一模一样。</p>
<p>该博主在视频中指出："这不是简单的'借鉴'或者'灵感来源'，这是逐段逐句的复制粘贴。和弦进行完全一致，旋律走向完全一致，甚至连编曲的一些细节处理都一样。"</p>
<p>被抄袭的音乐人多为国外的小众独立音乐人，在国内知名度不高，这也被认为是抄袭者敢于如此明目张胆的原因之一——"反正国内听众听不出来"。</p>
<p>视频发布后迅速登上热搜，大量网友在评论区表达了愤怒和失望。有不少该歌手的粉丝也表示"太失望了，脱粉了"。</p>
<p>截至目前，该歌手及其团队尚未做出任何回应。但音乐版权律师表示，如果被抄袭的音乐人选择起诉，该歌手可能面临巨额的版权赔偿。</p>`,
    category: 'mingxing',
    categoryName: '明星黑料',
    author: '黑料小编',
    publishDate: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20musical%20scores%20side%20by%20side%20with%20identical%20sections%20highlighted%20in%20red%2C%20plagiarism%20theme%2C%20dark%20desk%20setting%2C%20investigative%20mood%2C%20dramatic%20lighting%2C%20tense%20atmosphere&width=800&height=500&seq=article-13-hero&orientation=landscape',
    tags: ['抄袭', '音乐', '原创', '版权', '对比分析'],
    views: 85600,
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-14',
    title: '网红情侣分手互撕升级，男方爆料女方出轨，女方反击男方家暴',
    excerpt: '一对拥有超500万粉丝的网红情侣近日公开分手，双方在社交平台上隔空互撕，互相爆出对方的黑料。男方称女方出轨，女方则反击称男方长期家暴。',
    content: `<p>一场网红情侣的狗血分手大戏正在社交平台上实时上演。拥有超过500万粉丝的网红情侣"小A和小B"近日宣布分手，但分手并非好聚好散，而是演变成了一场公开的互相爆料的战争。</p>
<p>男方率先发难，发布长文称女方在恋爱期间多次出轨，并列出了所谓的"实锤证据"，包括女方与多名男性的暧昧聊天记录。男方还暗示，女方与他恋爱期间一直与其他男性保持不正当关系。</p>
<p>面对男方的指控，女方迅速做出强硬反击。她发布了一段视频，声称自己在恋爱期间长期遭受男方的家庭暴力，并展示了身上的伤痕照片。女方还表示，男方所谓的"出轨证据"全是断章取义和恶意剪辑。</p>
<p>双方的粉丝也迅速站队，在评论区展开激烈交锋。支持女方的人认为男方的爆料是"恶人先告状"，支持男方的人则声称女方的家暴指控是"为了洗白自己"。</p>
<p>这场互撕大戏越演越烈，双方不断放出新的"证据"和"内幕"，吸引了大量吃瓜群众围观。相关话题已连续多日占据热搜榜单。</p>
<p>业内人士表示，网红情侣的公开互撕往往带有很强的表演性质，不排除双方是在利用这场"分手大戏"博取流量和关注。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    author: '黑料小编',
    publishDate: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20showing%20a%20couple%20arguing%20through%20phones%2C%20social%20media%20drama%20theme%2C%20red%20and%20blue%20contrasting%20lighting%2C%20digital%20conflict%2C%20modern%20relationship%20drama%2C%20tense%20atmosphere&width=800&height=500&seq=article-14-hero&orientation=landscape',
    tags: ['网红情侣', '分手互撕', '出轨', '家暴', '吃瓜'],
    views: 112400,
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-15',
    title: '某影视公司拖欠演员片酬超千万，多名艺人联合讨薪无果',
    excerpt: '一家知名影视制作公司被爆长期拖欠演员片酬，涉及金额超过千万元。多名演员多次讨薪无果，已准备通过法律途径维权。事件暴露了影视行业的深层问题。',
    content: `<p>影视行业的欠薪问题再次浮出水面。近日，多位演员联合向媒体反映，某知名影视制作公司长期拖欠演员片酬，涉及金额已超过千万元。</p>
<p>据其中一位演员透露，他于2024年参与该公司制作的一部电视剧，合同约定的片酬至今仍有约80%未支付。"每次找他们要钱，都是各种理由拖延，什么'资金周转困难'、'项目还没回款'，翻来覆去就是那几句话。"</p>
<p>另一位女演员的遭遇更加令人同情。她在拍摄期间不仅没有收到片酬，还被公司以"项目融资需要"为由，要求她以个人名义贷款了200万元投入项目。如今项目已经播出，但她的片酬和贷款至今一分未回。</p>
<p>据不完全统计，该公司拖欠的演员片酬总额超过1200万元，涉及演员超过20人。此外，还有大量工作人员（如摄影师、化妆师、场务等）的劳务费也长期被拖欠。</p>
<p>业内人士指出，影视公司的资金链断裂是导致欠薪的主要原因。近年来，影视行业融资困难，加上回款周期长，导致许多中小型影视公司陷入财务困境。</p>
<p>目前，受影响的演员们已经联合聘请了律师，准备通过法律途径追讨欠薪。但律师坦言，即使胜诉，执行也是一大难题。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    author: '黑料小编',
    publishDate: '2026-07-31',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20unpaid%20contracts%20and%20invoices%20on%20a%20film%20production%20desk%2C%20financial%20crisis%20theme%2C%20dark%20office%20setting%2C%20dramatic%20lighting%2C%20entertainment%20industry%20problems%2C%20serious%20mood&width=800&height=500&seq=article-15-hero&orientation=landscape',
    tags: ['拖欠片酬', '影视公司', '讨薪', '行业问题', '维权'],
    views: 56300,
    isHot: false,
    isTop: false,
  },
];

export const getTopArticles = () => articles.filter((a) => a.isTop);
export const getHotArticles = () => articles.filter((a) => a.isHot && !a.isTop);
export const getLatestArticles = (limit = 10) =>
  [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
export const getArticlesByCategory = (slug: string) =>
  articles.filter((a) => a.category === slug);
export const getArticleById = (id: string) =>
  articles.find((a) => a.id === id) || null;